// extracted by mini-css-extract-plugin
export default {"viewReportSurvey":"viewReportSurvey_viewReportSurvey__ne6sQ","titleHeader":"viewReportSurvey_titleHeader__Fq85v","title":"viewReportSurvey_title__6OahQ"};